import { render } from "./urgeFoodModel.vue?vue&type=template&id=d2beaeb0"
import script from "./urgeFoodModel.vue?vue&type=script&lang=js"
export * from "./urgeFoodModel.vue?vue&type=script&lang=js"

import "./urgeFoodModel.vue?vue&type=style&index=0&id=d2beaeb0&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__